/** Prefijo de claves de subidas de la API (alineado con `STORAGE_OBJECT_KEY_PREFIX` en backend). */
const UPLOADS_PREFIX = "uploads/";

/**
 * Obtiene la clave S3 almacenable en `user.image` a partir de lo que haya en BD:
 * - ya es `uploads/...` → se devuelve tal cual;
 * - URL https a nuestro bucket / CDN con ruta `/uploads/...` → se extrae la clave;
 * - URL externa (p. ej. Gravatar) sin `uploads/` → null (usar URL directa).
 */
export function storageObjectKeyFromUserImageField(raw: string): string | null {
  const t = raw.trim();
  if (!t) return null;
  if (t.startsWith(UPLOADS_PREFIX)) return t;
  if (t.startsWith("http://") || t.startsWith("https://")) {
    try {
      const u = new URL(t);
      const path = u.pathname.replace(/^\/+/, "");
      if (path.startsWith(UPLOADS_PREFIX)) return path;
    } catch {
      return null;
    }
  }
  return null;
}

/** Si es una URL http(s) que no corresponde a objeto bajo `uploads/`, mostrar tal cual. */
export function isDirectExternalAvatarUrl(raw: string): boolean {
  const t = raw.trim();
  if (!t) return false;
  if (!t.startsWith("http://") && !t.startsWith("https://")) return false;
  return storageObjectKeyFromUserImageField(t) === null;
}
